<template>
  <div class="ivu-poptip-popper ui-poptip" x-placement="right" :style="{ width, top, left, right }">
    <div class="ivu-poptip-content">
      <div class="ivu-poptip-arrow"></div>
      <div class="ivu-poptip-inner">
        <div class="ivu-poptip-body">
          <div class="ivu-poptip-body-content ivu-poptip-body-content-word-wrap">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Popup',
    props: {
      width: {
        type: String,
        default: '250px'
      },
      top: {
        type: String,
        default: '10px'
      },
      left: {
        type: String,
        default: '370px'
      },
      right: {
        type: String,
        default: 'inherit'
      }
    }
  };
</script>
<style>
  .ui-poptip {
    position: absolute;
    will-change: top, left;
  }

  .ivu-poptip-popper[x-placement^='right'] .ivu-poptip-arrow {
    left: 4px;
  }

  .ivu-poptip-content p {
    margin-bottom: 0;
  }
</style>
